import React, { Component } from 'react';
import CancelUrl from '../CancelUrl/CancelUrl';
import FooterLinks from './FooterLinks';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './Footer.less';

export class Footer extends Component {
    static propTypes = {
        dispatchCancelFPTI: PropTypes.func,
        errorType: PropTypes.string,
        pageName: PropTypes.string,
        showCancelUrl: PropTypes.bool,
        cookieBannerAvailable: PropTypes.bool
    };

    static defaultProps = {
        showCancelUrl: true,
        cookieBannerAvailable: false
    };

    shouldShowCancelUrl = () => {
        const { errorType, showCancelUrl } = this.props;
        const isInvalidFlow = errorType === 'invalidFlow';

        return showCancelUrl && !isInvalidFlow;
    };

    render() {
        const { errorType, pageName, cookieBannerAvailable } = this.props;
        return (
            <footer id="cue-footer">
                <div className={cookieBannerAvailable ? 'cookieBanner' : ''}>
                    {this.shouldShowCancelUrl() && (
                        <CancelUrl
                            fptiEvent={{
                                stateName: `apply_pp_credit_${pageName}`,
                                transitionName: `cancel_and_return_apply_pp_credit_${pageName}`
                            }}
                        />
                    )}
                    <FooterLinks />
                </div>
            </footer>
        );
    }
}

export const mapStateToProps = state => ({
    errorType: state.serverData.errorType,
    pageName: state.skeletonPage.currentPage,
    cookieBannerAvailable: state.serverData.cookieBannerAvailable || false
});

export default connect(mapStateToProps)(Footer);
